import * as React from 'react';
import { useEffect, useState } from 'react';
import { UseFormMethods } from 'react-hook-form';

interface IRHFPillToggleProps extends Partial<Pick<UseFormMethods, 'register' | 'setValue'>> {
    name: string;
    items: Array<string>;
    defaultValue?: string;
    disabled?: boolean;
    style?: React.CSSProperties;
    onChange?: (value: string) => void;
}

// react-hook-form equivalent of FormToggle.tsx (which is built on react-final-form's Field
// render prop) - a pill-style segmented toggle instead of a plain <select> (see RHFToggle).
// Reuses FormToggle's own .dlc-form-toggle styling so it looks identical. RHF's register() only
// attaches to a real form control, and a clicked <span> isn't one, so the selected value is kept
// in local state and pushed into the form via setValue, with a hidden input registered under
// `name` so the field still shows up in getValues()/handleSubmit like any other RHF field.
const RHFPillToggle = (props: IRHFPillToggleProps) => {
    const [selected, setSelected] = useState<string | undefined>(props.defaultValue);

    useEffect(() => {
        if (props.setValue) {
            props.setValue(props.name, props.defaultValue);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleClick = (item: string) => {
        if (props.disabled || item === selected) {
            return;
        }
        setSelected(item);
        if (props.setValue) {
            props.setValue(props.name, item, { shouldDirty: true });
        }
        if (props.onChange) {
            props.onChange(item);
        }
    };

    return (
        <div className={`dlc-form-toggle ${props.disabled ? 'disabled' : ''}`} style={props.style}>
            <input type="hidden" name={props.name} ref={props.register} defaultValue={props.defaultValue} />
            {props.items.map((item) => (
                <span key={item} className={item === selected ? 'selected' : ''} onClick={() => handleClick(item)}>
                    {item}
                </span>
            ))}
        </div>
    );
};

export default RHFPillToggle;



// WEBPACK FOOTER //
// ./src/components/controls/tempRHFControls/RHFPillToggle.tsx